// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
    IconKey
} from '@tabler/icons-react';

import { NavItemType } from 'types';

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const pages: NavItemType = {
    id: 'pages',
    type: 'group',
    children: [
        {
            id: 'key',
            title: <FormattedMessage id="key" />,
            type: 'item',
            url: '/key',
            icon: IconKey,
            breadcrumbs: false
        }
        // {
        //     id: 'reserve-room',
        //     title: <FormattedMessage id="meeting-room" />,
        //     type: 'item',
        //     url: '/room',
        //     icon: IconPresentationAnalytics,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'reserve-seat',
        //     title: <FormattedMessage id="seat" />,
        //     type: 'item',
        //     url: '/seat',
        //     icon: IconDesk,
        //     breadcrumbs: false
        // }

        // {
        //     id: 'store',
        //     title: <FormattedMessage id="store" />,
        //     type: 'item',
        //     url: '/store',
        //     icon: IconBuildingStore,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'ap',
        //     title: <FormattedMessage id="ap" />,
        //     type: 'item',
        //     url: '/ap',
        //     icon: IconRouter,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'tag',
        //     title: <FormattedMessage id="tag" />,
        //     type: 'item',
        //     url: '/tag',
        //     icon: IconDevices,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'anchor',
        //     title: <FormattedMessage id="anchor" />,
        //     type: 'item',
        //     url: '/anchor',
        //     icon: IconMapPin,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'camera',
        //     title: <FormattedMessage id="camera" />,
        //     type: 'item',
        //     url: '/camera',
        //     icon: IconCamera,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'item',
        //     title: <FormattedMessage id="item" />,
        //     type: 'item',
        //     url: '/item',
        //     icon: IconBox,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'task',
        //     title: <FormattedMessage id="task" />,
        //     type: 'item',
        //     url: '/task',
        //     icon: IconNotes,
        //     breadcrumbs: false
        // },
        // {
        //     id: 'template',
        //     title: <FormattedMessage id="template" />,
        //     type: 'item',
        //     icon: IconPalette,
        //     url: '/template',
        //     target: true
        // }
    ]
};

export default pages;
